import React, {Suspense} from "react"
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as t from "counterpart";
import {Icon, Navbar, FocusStyleManager, Popover, Menu, Card, Callout} from "@blueprintjs/core";
import {BrowserRouter as Router, Link, NavLink, Route, Redirect, Switch} from "react-router-dom";
import moment from "moment";
import * as actions from "../../actions";
import Login from "../Login";

import "./style.scss";

FocusStyleManager.onlyShowFocusOnTabs();

const useVerticalNav = process.env.REACT_APP_VERTICAL_NAV;
let counter = 0;

// loading logo
let logo = "/assets/logo.svg";
let loadingLogo = (
	<div className="logo">
		<img src="/assets/logo.svg" alt=""/>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="-512.141 -512.141 512.141 512.141"> <g transform="translate(-1)"> <path fill="#2C3E50" d="M186.45 432.622H327.69100000000003V485.588H186.45z" ></path> <path fill="#556080" d="M513.071 370.829v30.455c1.261 20.815-14.506 38.749-35.31 40.165H36.381c-20.805-1.417-36.571-19.351-35.31-40.165v-30.455h512z" ></path> <path fill="#3D324C" d="M513.071 40.236v330.593h-512V40.236C-.19 19.421 15.576 1.487 36.381.071H477.76c20.805 1.416 36.571 19.35 35.311 40.165z" ></path> <path fill="#F3D55B" d="M168.795 81.373v109.639a3.434 3.434 0 01-3.531 3.266H66.395a3.363 3.363 0 01-3.531-3.178V81.373l50.229-45.021a4.265 4.265 0 015.473 0l50.229 45.021z" ></path> <path fill="#F0C419" d="M115.829 229.588v52.966l-44.138 26.483-1.236.794a52.141 52.141 0 01-7.592-27.277c.001-29.253 23.714-52.966 52.966-52.966z" ></path> <path fill="#FF5364" d="M168.795 282.553a52.471 52.471 0 01-15.537 37.429l-37.429-37.429v-52.966c29.252.001 52.966 23.714 52.966 52.966z" ></path> <path fill="#24AE5F" d="M153.258 319.982a52.889 52.889 0 01-82.803-10.151l1.236-.794 44.138-26.483 37.429 37.428z" ></path> <path fill="#F0C419" d="M292.381 44.209h17.655a8.828 8.828 0 018.828 8.828v105.931h-35.31V53.036a8.826 8.826 0 018.827-8.827z" ></path> <path fill="#FF5364" d="M360.618 88.346h22.422a6.444 6.444 0 016.444 6.444v64.177h-35.31V94.791a6.445 6.445 0 016.444-6.445z" ></path> <path fill="#24AE5F" d="M429.888 114.829h25.114a5.094 5.094 0 015.094 5.094v39.044h-35.302v-39.044a5.095 5.095 0 015.094-5.094z" ></path> <path fill="#FF5364" d="M248.243 309.036a8.829 8.829 0 01-6.241-15.069l31.656-31.656c10.482-10.002 26.974-10.002 37.455 0l10.337 10.346a8.828 8.828 0 0012.482 0l36.829-36.829c10.479-10.001 26.968-10.001 37.447 0l10.346 10.346a8.828 8.828 0 0012.482 0l31.656-31.647a8.828 8.828 0 0112.483 12.483l-31.656 31.656c-10.354 10.309-27.093 10.309-37.447 0l-10.346-10.355a9.013 9.013 0 00-12.482 0l-36.829 36.829c-10.342 10.338-27.105 10.338-37.447 0l-10.346-10.346a9.013 9.013 0 00-12.482 0l-31.656 31.656a8.827 8.827 0 01-6.241 2.586z" ></path> <path fill="#556080" d="M142.312 476.76h229.517c14.626 0 26.483 11.857 26.483 26.483v8.828H115.829v-8.828c0-14.626 11.857-26.483 26.483-26.483z" ></path> <g fill="#FF5364"> <path d="M186.45 106.002a8.829 8.829 0 01-5.888-2.251l-64.733-57.944-64.733 57.944c-3.638 3.197-9.173 2.866-12.404-.743s-2.951-9.146.628-12.41l67.902-60.787a13.011 13.011 0 0117.055-.132l68.061 60.91a8.829 8.829 0 01-5.888 15.413z"></path> <path d="M62.864 90.2a8.828 8.828 0 01-8.828-8.828V57.45a8.828 8.828 0 0117.656 0v23.923a8.829 8.829 0 01-8.828 8.827z"></path> </g> <g fill="#B49ACA"> <path d="M468.933 167.795H265.898c-14.626 0-26.483-11.857-26.483-26.483V35.381a8.828 8.828 0 0117.656 0v105.931a8.828 8.828 0 008.828 8.828h203.034a8.828 8.828 0 010 17.655zM468.933 344.346H265.898c-14.626 0-26.483-11.857-26.483-26.483v-105.93a8.828 8.828 0 0117.656 0v105.931a8.828 8.828 0 008.828 8.828h203.034a8.828 8.828 0 010 17.654z"></path> </g> </g> </svg>
	</div>
);

if(process.env.REACT_APP_CLIENT_BH) {
	logo = "/assets/bh_logo.png";
	loadingLogo = (
		<div className="logo">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="-400 -530 800 800"><path stroke="rgb(255, 255, 255)" strokeWidth="3px" fill="none" d="M384.463,20.615 C416.777,20.615 449.100,20.615 481.414,20.615 C481.414,81.576 481.414,142.556 481.414,203.518 C521.389,203.518 561.377,203.518 601.353,203.518 C601.353,142.556 601.353,81.576 601.353,20.615 C633.667,20.615 665.990,20.615 698.304,20.615 C698.304,158.528 698.304,296.482 698.304,434.395 C735.582,419.553 767.152,398.216 782.262,361.434 C788.095,347.232 784.046,327.861 790.257,311.461 C791.245,336.356 791.608,358.053 783.261,377.426 C748.589,457.896 603.939,494.175 481.414,470.376 C321.643,439.342 180.862,382.002 96.608,275.480 C63.421,233.521 22.669,180.506 42.636,103.571 C42.969,103.571 43.302,103.571 43.635,103.571 C33.299,163.254 66.373,229.560 99.607,254.491 C99.940,193.196 100.273,131.883 100.606,70.588 C100.606,58.614 97.740,12.221 102.605,6.622 C122.521,-2.782 165.765,3.624 191.560,3.624 C290.188,3.623 359.561,4.580 383.463,79.584 C383.796,79.584 384.130,79.584 384.463,79.584 C384.463,59.929 384.463,40.269 384.463,20.615 ZM224.544,80.583 C221.545,81.249 218.546,81.916 215.548,82.582 C215.548,141.878 215.548,201.192 215.548,260.488 C215.548,282.052 209.824,319.243 217.547,336.447 C235.203,345.442 252.864,354.439 270.520,363.433 C270.854,340.114 271.187,316.789 271.520,293.470 C329.977,290.788 390.281,281.762 410.450,323.454 C415.366,333.618 417.390,351.017 412.449,363.433 C407.045,377.010 394.537,389.507 380.465,394.416 C373.939,396.693 357.301,394.069 353.478,399.414 C372.585,402.773 411.448,424.007 428.441,420.403 C465.032,405.272 482.242,338.346 457.426,297.468 C437.600,264.810 420.976,267.598 385.462,252.492 C386.129,252.492 386.795,252.492 387.461,252.492 C401.547,240.600 414.842,231.992 424.443,215.511 C454.391,164.101 418.291,103.781 380.465,87.579 C344.130,72.017 272.765,80.145 224.544,80.583 ZM268.521,218.510 C268.521,187.529 268.521,156.540 268.521,125.559 C319.915,118.067 395.253,119.877 382.464,180.530 C373.051,225.173 321.955,221.988 268.521,218.510 ZM6.654,131.556 C6.987,132.555 7.320,133.555 7.653,134.554 C7.320,134.554 6.987,134.554 6.654,134.554 C6.654,133.555 6.654,132.555 6.654,131.556 ZM100.606,476.373 C100.273,435.732 99.940,395.079 99.607,354.438 C88.280,342.778 76.951,331.116 65.624,319.456 C26.155,270.150 -9.702,221.213 5.654,134.554 C5.988,134.554 6.321,134.554 6.654,134.554 C0.303,219.577 39.407,266.268 81.616,308.462 C172.867,399.680 296.110,454.808 442.433,491.365 C558.580,520.382 725.196,509.848 780.263,435.395 C790.431,421.646 798.139,403.828 802.251,384.422 C802.918,374.095 803.584,363.765 804.250,353.438 C805.671,379.691 805.963,404.170 797.254,424.401 C760.468,509.849 608.656,548.641 478.415,524.348 C437.700,516.753 398.338,509.939 361.474,498.361 C343.485,491.699 325.491,485.034 307.502,478.372 C287.847,478.372 268.186,478.372 248.532,478.372 C199.639,478.372 146.260,479.556 100.606,476.373 ZM481.414,294.470 C481.414,344.771 481.414,395.088 481.414,445.389 C519.072,447.152 558.791,454.196 601.353,452.386 C601.353,399.752 601.353,347.103 601.353,294.470 C561.377,294.470 521.389,294.470 481.414,294.470 Z"/></svg>
			<img src="/assets/loading_logo.png" alt=""/>
		</div>
	)
}

class Layout extends React.Component
{
	isOpen = false;

	//
	constructor(props)
	{
		super(props);

		this.state = {
			local: "ar",
			activeAppIndex: window.location.pathname.split("/")[1],
			routes: props.routes || [],
			navigation: props.navigation || [],
			showMobileSidebar: false,
		};

		window.document.body.classList.add("dir-"+t("dir"));
	}

	//
	componentDidMount() {
		this.props.loadUser();
		this.props.loadNotifications();
	}

	changeLocal = () =>
	{
		let local = this.state.local === "en" ? "ar" : "en";
		t.setLocale(local);
		this.setState({local});

		if(t("dir") === "rtl") {
			window.document.body.classList.add("dir-rtl");
		} else {
			window.document.body.classList.remove("dir-rtl");
		}
	};

	render()
	{
		const {portal, login, logout} = this.props;
		const {routes, navigation, showMobileSidebar, activeAppIndex} = this.state;
		const {user, ready, error} = portal;
		const ConnectBlock = window.ConnectBlock || "div";

		counter++;

		if(!ready)
		{
			return (
				<div id="portal-loading">
					{loadingLogo}
					{error && <Callout intent="danger" title={error} />}
				</div>
			);
		}

		if(!user) {
			return <Login onSubmit={login} error={error} />;
		}

		const appTooltipDir = t("right");
		const menuIcon = "chevron-"+appTooltipDir;

		function sideMenu(root, level=1, permissionsApp)
		{
			return (
				<div className={"level-"+level}>
					{root.name && <h3>{t(root.name)}</h3>}
					<ul>
						{(root.pages || []).filter(item => (!item.permission || user.can(permissionsApp, item.permission))).map((item, i) =>
							<li key={i} className={item.className}>
								{item.isGroup ? sideMenu(item, level+1, permissionsApp) : <NavLink exact to={item.link+"?"+counter || "404"}><Icon icon={menuIcon}/> {t(item.name)}</NavLink>}
							</li>
						)}
					</ul>
				</div>
			);
		}

		const userMenu = (position) => (
			<Popover className="user-menu" wrapperTagName="div" targetTagName="div" content={
				<Menu>
					<h6>{t("Personal Portal")}</h6>
					<Menu.Item text={t("My Account")} tagName={Link} to="/profile"/>
					<Menu.Item text={t("My Vacations")} tagName={Link} to="/personal/vacations"/>
					{/*<Menu.Item text={t("My Tickets")} tagName={Link} to="/personal/tickets"/>*/}
					{/*<Menu.Item text={t("My Attendance")} tagName={Link} to="/personal/attendances"/>*/}
					{/*<Menu.Item text={t("My Payments")} tagName={Link} to="/personal/payables"/>*/}
					{/*<Menu.Item text={t("My Training")} tagName={Link} to="/personal/training"/>*/}
					{/*<Menu.Item text={t("My Loans")} tagName={Link} to="/personal/loans"/>*/}
					{/*<Menu.Item text={t("My Installments")} tagName={Link} to="/personal/installments"/>*/}
					<Menu.Divider />
					<Menu.Item text={t("Logout")} tagName={Link} onClick={logout}/>
					{/*<Menu.Divider />*/}
					{/*<Menu.Item icon="translate" text={t.getLocale() === "en" ? "عربي" : "English"} onClick={this.changeLocal}/>*/}
					{/*<Menu.Item icon="fullscreen" text={t("Full Screen")} onClick={fullScreen}/>*/}
				</Menu>
			} position={position}>
				<div>
					{user.image && <img src={user.image} alt="" />}
					<div>
						<h3><span> {user.first_name} </span><Icon icon="caret-down" iconSize="20" /></h3>
						<h5>{user.first_name}</h5>
					</div>
				</div>
			</Popover>
		);

		const notificationsMenu = (
			<Menu id="notifications-menu">
				{portal.notifications.map(n =>
					<Menu.Item key={n.id} text={n.message} />
				)}
			</Menu>
		);

		const navTime = moment();
		const useClick = user.can("core", "menu-click");

		return (
			<div id="portal">
				<Router basename={process.env.PUBLIC_URL}>
					<Navbar id="navbar">
						<div className="d-md-none">
							<Icon icon="menu" onClick={() => this.setState({showMobileSidebar: true})} />
						</div>
						<Link id="logo" to="/"><img src={logo} alt=""/></Link>

						<ConnectBlock />

						{/*<div id="global-search" className="bp3-input-group">
							<input
								type="text"
								className="bp3-input"
								placeholder={t("global_search_placeholder")}
								onChange={e => this.setState({search: e.target.value})}
								onMouseEnter={e => {
									if(e.key === "Enter") {
										goToSearch()
									}
								}}
							/>
							<Button minimal className="bp3-icon-search" onClick={goToSearch} />
						</div>*/}
						<div id="nav-time" className="d-none d-lg-block">
							<h5>{navTime.format("ddd, hh:mm A")}</h5>
							{navTime.format("DD-MM-YYYY")}
						</div>
						<Popover className="notifications" content={notificationsMenu} position="bottom" modifiers={{arrow: {enabled: false}}}>
							<div>
								<Icon icon="notifications" iconSize="35"/>
								{portal.notifications.length !== 0 && <span className="badge">{portal.notifications.length}</span>}
							</div>
						</Popover>
						<div id="user-menu">{userMenu("bottom")}</div>
					</Navbar>

					<div id="wrapper" className={useVerticalNav ? "vertical-sidebar" : "horizontal-sidebar"}>
						<div id="sidebar" className={showMobileSidebar ? "show-mobile-sidebar" : ""}>
							<div className="d-md-none">
								<Icon className="close" icon="cross" iconSize="20" onClick={() => this.setState({showMobileSidebar: false})} />
							</div>

							<ul id="apps-list" className="container">
								{navigation.sort((a, b) => (a.order  || 0)- (b.order  || 0))
									.filter(app => user.can("core", app.permission || app.id))
									.map((app, i) =>
									<li
										key={i}
										id={"app-"+app.id}
										className={app.id === activeAppIndex ? "active "+(useClick && this.isOpen ? "show-submenu" : "") : ""}
										onMouseEnter={(e) => !useClick && e.currentTarget.classList.add("show-submenu")}
										onMouseLeave={(e) => !useClick && e.currentTarget.classList.remove("show-submenu")}
										onClick={(e) => {
											this.setState({activeAppIndex: app.id});
											if(!useClick) {
												e.currentTarget.classList.remove("show-submenu");
											}

											this.isOpen = !this.isOpen;
										}}
									>
										<Link to={useClick ? "#" : (app.link || "#")}>
											<i className={"apps-icons "+app.icon}/>
											<span className="name">{t(app.name)}</span>
										</Link>

										{app.pages.length !== 0 && <div className="submenu">{sideMenu(app, 1, app.appID)}</div>}
									</li>
								)}
							</ul>
						</div>

						<div id="page-content">
							<Card id="page-panel">
								<Suspense fallback={<div>{t("Loading")}...</div>}>
									<Switch>
										<Route path="/" exact component={() => <Redirect to={"/home"} />}/>
										{routes}
										<Route key="404" component={() => <div id="page-404"><img src="/assets/404.png" alt=""/></div>} />
									</Switch>
								</Suspense>
							</Card>
						</div>
					</div>
				</Router>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {portal: state.portal}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(actions, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
